export default "/images/right-arrow-orange.svg?ddedb59410a44bbb2c19dcf67c380acc";